import Banner from 'components/Banner';
import BottomCustomer from 'components/BottomCustomer';
import TopCoupon from 'components/TopCoupon';
import React, { useEffect, useState, useContext } from 'react';
import { Helmet } from "react-helmet";
import ModalContext from 'contexts/ModalContext';
import { GetAllBranch, GetAllBrand } from 'services/Api/Module/Brand';
import { GetAllCoupon, GetCoupon, GetCouponType } from 'services/Api/Module/Coupon';
import useProfileStore from 'services/store/ProfileModule';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Pagination from 'components/Pagination';
import EmptyCoupon from 'components/EmptyCoupon';
import useTranslations from 'i18n/useTranslations';
import PullToRefresh from 'components/pullToRefresh/PullToRefresh';
import { GetCustomerProfile } from 'services/Api/Module/Customer';

import { GetAllPromotion, GetPromotionDetails} from 'services/Api/Module/Promotion';
import EmptyPromotion from 'components/EmptyPromotion';

const DEF_LIMIT = 10;
const DEF_OFFSET = 0;
const MIN_DATE = "2024-01";

const DEF_RES_ID = 76 // ร้านเริ่มต้น

const CouponAll = () => {
    const profile = useProfileStore();
    const { mAlert } = useContext(ModalContext);
    let [searchParams, setSearchParams] = useSearchParams();
    const [topProfile, setTopProfile] = useState();
    // lang and refresh
    const { lang, supportedLangs, setLang } = useTranslations(); // สำหรับเปลี่ยนภาษา
    const { t } = useTranslations();
    const [refreshing, setRefreshing] = useState(false)

    // Main DATA
    const limit = DEF_LIMIT;
    const offset = searchParams.get("offset") ?? DEF_OFFSET;
    const [coupon, setCoupon] = useState();
    const [rowCount, setRowCount] = useState(0);

    const [promotion, setPromotion] = useState();
    const [rowCountPromotion, setRowCountPromotion] = useState(0);


    // SELECT
    const selectedBrandId = searchParams.get('restaurantId') || DEF_RES_ID;;
    const selectedBranchId = searchParams.get('branchId') || 0;
    const selectedCouponTypeId = searchParams.get('couponTypeId') || 0;
    const navigate = useNavigate();

    const [selectedBranch, setSelectedBranch] = useState(0);
    const [selectedCouponType, setSelectedCouponType] = useState(0);
    const [hasBranch, setHasBranch] = useState(0)

    // LIST
    const [brand, setBrand] = useState([]);
    const [branch, setBranch] = useState([]);
    const [couponType, setCouponType] = useState([]);
    const [randomBrands, setRandomBrands] = useState([]);

    // OTHER
    const [isFirstClick, setIsFirstClick] = useState(false);
    const tempParams = {
        restaurantId: selectedBrandId,
        branchId: selectedBranchId,
        couponTypeId: selectedCouponTypeId,
        offset: offset
    }

    // FN..
    const getRandomBrands = (brands, count) => {
        const shuffled = brands.sort(() => 0.5 - Math.random());
        return shuffled.slice(0, count);
    };

    const setInitialBrands = () => {
        setSearchParams({ ...tempParams, restaurantId: selectedBrandId });
        let payload = {
            restaurant: selectedBrandId
        }
        fetchGetAllBranch(payload, selectedBrandId);
        handleBrandClick(selectedBrandId);
    };

    const handleLogoClick = async (clickedBrandId) => {
        if (!isFirstClick) {
            setIsFirstClick(true);
        }
        let payload = {
            restaurant: clickedBrandId
        }
        setSearchParams({ ...tempParams, restaurantId: clickedBrandId, branchId: 0, couponTypeId: 0 });

        await fetchGetAllBranch(payload, clickedBrandId);//fetch branch

        handleBrandClick(clickedBrandId);//update random brand
    };
    const handleBrandClick = (clickedBrandId) => {
        const remainingBrands = brand.filter(item => item.id != clickedBrandId && item.id != DEF_RES_ID);
        const newRandomBrands = getRandomBrands(remainingBrands, 3);
        const clickedBrand = brand.find(item => item.id == clickedBrandId) ?? {};
        setRandomBrands([clickedBrand, ...newRandomBrands]);
    }
    const images = randomBrands.map((item, index) => (
        <a href={item.link} key={index} onClick={() => handleLogoClick(item.id)}>
            <div className="bLogo">
                <img src={item.logoImg} alt={item.name} />
            </div>
        </a>
    ));
    const checkLimit = (coupon) => {
        if (coupon.limits == 1) {
            if (coupon.amountUse >= coupon.amount) {
                return 1;
            }
            if (coupon.custAmountUse >= coupon.custLimit) {
                return 1;
            }
            return 0;
        } else {
            if (coupon.custAmountUse >= coupon.custLimit) {
                return 1;
            }
            return 0;
        }
    }

    // Handle Event
    const handleCouponTypeClick = (id) => {
        setSearchParams({ ...tempParams, offset: 0, couponTypeId: id })
    };
    const findCouponTypeName = (id) => {
        const couponName = couponType.find(type => type.id === id);
        return couponName ? couponName.name : 'Unknown';
    };
    const handleCouponClick = (id, branchId, brand, item) => {
        let limit = checkLimit(item)
        navigate(`/coupon-detail?couponId=${id}&restaurantId=${brand}&branchId=${branchId}&limit=${limit}`);
    };
    const handleRefresh = () => {
        console.log('handleRefresh!!!')
        setRefreshing(true)
        onLoad();
    };
    const [selectedCategory, setSelectedCategory] = useState('coupon');

    const handleCategoryChange = (category) => {
        setSelectedCategory(category);
    };

    const handlePromotionClick = (id, brand) => {
        navigate(`/promotion-detail?promotionId=${id}&restaurantId=${brand}`);
    };

    // CALL API
    const fetchGetAllBrand = async () => {
        try {
            const response = await GetAllBrand();
            const resData = response?.data;
            setRefreshing(false)
            if (resData.resultCode === 20000) {
                setBrand(resData.resultData);
                // setInitialBrands(resData.resultData);
            } else {
                mAlert.info({
                    title: "ไม่พบ brand",
                    subTitle: "ไม่พบ brand",
                    content: "",
                    onClose: () => { },
                });
            }
        } catch (err) {
            setRefreshing(false)
            console.log('err ', err);
            mAlert.info({
                title: "แจ้งเตือน",
                subTitle: "มีบางอย่างผิดพลาด",
                content: "",
                onClose: () => { },
            });
        }
    };
    const fetchGetAllBranch = async (payload, clickedBrandId) => {
        try {
            const response = await GetAllBranch({ params: payload });
            const resData = response?.data;
            if (resData.resultCode === 20000) {
                setBranch(resData.resultData);
                if (resData.resultData.length > 0) {
                    const firstBranchId = resData.resultData[0].id;
                    setSearchParams({ ...tempParams, restaurantId: clickedBrandId, branchId: firstBranchId,offset: 0 });
                }
            } else {
                mAlert.info({
                    title: "ไม่พบ brand",
                    subTitle: "ไม่พบ brand",
                    content: "",
                    onClose: () => { },
                });
            }
        } catch (err) {
            console.log('err ', err);
            mAlert.info({
                title: "แจ้งเตือน",
                subTitle: "มีบางอย่างผิดพลาด",
                content: "",
                onClose: () => { },
            });
        }
    };
    const fetchGetProfile = async (payload) => {
        try {
            const response = await GetCustomerProfile({ params: payload });
            const resData = response?.data;
            // console.log(response.data)
            setTopProfile(resData?.resultData)
            console.log('topProfile',resData?.resultData)
            // setProfile(resData?.resultData);
            setRefreshing(false)
        } catch (err) {
            console.log('err ', err);
            setRefreshing(false)
            mAlert.info({
                title: "แจ้งเตือน",
                subTitle: "มีบางอย่างผิดพลาด",
                content: "",
                onClose: () => { },
            });
        }
    };
    const fetchGetCouponType = async () => {
        try {
            const response = await GetCouponType();
            const resData = response?.data;
            setRefreshing(false)
            if (resData.resultCode === 20000) {
                setCouponType(resData.resultData);
            } else {
                mAlert.info({
                    title: "ไม่พบ coupon Type",
                    subTitle: "ไม่พบ coupon Type",
                    content: "",
                    onClose: () => { },
                });
            }
        } catch (err) {
            setRefreshing(false)
            console.log('err ', err);
            mAlert.info({
                title: "แจ้งเตือน",
                subTitle: "มีบางอย่างผิดพลาด",
                content: "",
                onClose: () => { },
            });
        }
    };
    const fetchGetCoupon = async (payload) => {
        try {
            const response = await GetCoupon({ params: payload });
            const resData = response?.data;
            if (resData.resultCode === 20000) {
                setCoupon(resData.resultData);
                setRowCount(resData.rowCount)
            } else {
                mAlert.info({
                    title: "ไม่พบ coupon",
                    subTitle: "ไม่พบ coupon",
                    content: "",
                    onClose: () => { },
                });
            }
        } catch (err) {
            console.log('err ', err);
            mAlert.info({
                title: "แจ้งเตือน",
                subTitle: "มีบางอย่างผิดพลาด",
                content: "",
                onClose: () => { },
            });
        }
    };

    const fetchGetAllCoupon = async (payload) => {
        try {
            const response = await GetAllCoupon({ params: payload });
            const resData = response?.data;
            if (resData.resultCode === 20000) {
                setCoupon(resData.resultData);
                setRowCount(resData.rowCount)
            } else {
                mAlert.info({
                    title: "ไม่พบ coupon",
                    subTitle: "ไม่พบ coupon",
                    content: "",
                    onClose: () => { },
                });
            }
        } catch (err) {
            console.log('err ', err);
            mAlert.info({
                title: "แจ้งเตือน",
                subTitle: "มีบางอย่างผิดพลาด",
                content: "",
                onClose: () => { },
            });
        }
    };

    const fetchGetAllPromotion = async (payload) => {
        try {
            const response = await GetAllPromotion({ params: payload });
            const resData = response?.data;
            if (resData.resultCode === 20000) {
                setPromotion(resData.resultData)
                setRowCountPromotion(resData.rowCount)
            } else {
                setRowCountPromotion(0)
                // mAlert.info({
                //     title: "ไม่พบ promotion",
                //     subTitle: "ไม่พบ promotion",
                //     content: "",
                //     onClose: () => { },
                // });
            }
        } catch (err) {
            console.log('err ', err);
            mAlert.info({
                title: "แจ้งเตือน",
                subTitle: "มีบางอย่างผิดพลาด",
                content: "",
                onClose: () => { },
            });
        }
    };

    // USE EFFECT
    useEffect(() => {

        let payload = {
            restaurant: selectedBrandId,
            customer: topProfile?.id,
            limit: limit,
            offset: offset,
            restaurantBranch: selectedBranchId != 0 ? selectedBranchId : undefined,
            couponType: selectedCouponTypeId != 0 ? selectedCouponTypeId : undefined
        };
        console.log("brand", selectedBrandId)
        if (selectedBrandId && topProfile?.id) {
            if (selectedBrandId == DEF_RES_ID) {
                fetchGetAllCoupon(payload);
            } else {
                fetchGetCoupon(payload);
            }
        }


        const _hasBranch = brand.find(item => item.id == selectedBrandId)?.hasBranch ?? 0
        setHasBranch(_hasBranch)
    }, [offset, topProfile, selectedCouponTypeId, selectedBranchId])

    useEffect(() => {
        setInitialBrands();
        const _hasBranch = brand.find(item => item.id == selectedBrandId)?.hasBranch ?? 0
        setHasBranch(_hasBranch)
    }, [brand]);

    const onLoad = () => {
        fetchGetAllBrand();
        fetchGetCouponType();
        const payload = {
            lineUid: profile?.lineUid
        };
        fetchGetProfile(payload)
        console.log('fetchdi',profile)
    }

    useEffect(() => {
        onLoad()
    }, [lang,profile]);

    useEffect(() => {
        if (selectedCategory === 'promotion') {
            // สร้าง payload ที่มีเฉพาะค่า restaurantId, offset และ limit
            let payload = {
                limit: limit,
                offset: offset
            };

            if (Number(selectedBrandId) !== DEF_RES_ID) {
                payload.restaurantId = selectedBrandId;
            }

            // ตรวจสอบว่า restaurantId มีค่าหรือไม่
            if (selectedBrandId) {
                fetchGetAllPromotion(payload);
            }

            // ปรับค่าของ hasBranch ถ้ามีการเลือก restaurant
            const _hasBranch = brand.find(item => item.id === selectedBrandId)?.hasBranch ?? 0;
            setHasBranch(_hasBranch);
        }
    }, [selectedCategory, offset, selectedBrandId, limit]);


    const selectedBrand = brand.find(item => item.id == selectedBrandId) ?? {};
    return (
        <div>
            <PullToRefresh
                dragHeight={50}
                refreshing={refreshing}
                onRefresh={handleRefresh}
            >
                <Helmet>
                    <title>IMPACT Family</title>
                    <meta name="title" content="Impact Family" />
                    <meta name="description" content="Impact Family" />
                    <meta name="keyword" content="" />
                    <meta property="og:title" content="Impact Family" />
                    <meta property="og:description" content="Impact Family" />
                    <meta property="og:image" content="" />
                    <meta property="og:url" content="" />
                    <meta property="og:type" content="website" />
                    <meta property="og:site_name" content="Impact Family" />
                </Helmet>
                <div id="pageCoupon-all">


                    <main id="top">
                        <div className="wrapContent">
                            <TopCoupon
                                custName={topProfile ? `${lang == 'th' ? 'สวัสดี คุณ' : 'Hello,'}${topProfile?.firstName}` : ''}
                                point={topProfile?.pointOnHand}
                                expiredDate={topProfile?.expiredDate}
                                expiredPoint={topProfile?.expiredPoint}
                                profileImg={profile?.profile?.pictureUrl ? profile.profile.pictureUrl : "assets/img/logo/logo-color.svg"}
                                rank={profile?.customerProfile?.rank}
                            />

                            <Banner />

                            <section id="pRestaurant">
                                <div className="bRestaurant">
                                    <h2>{t.coupon.allRestaurant}</h2>
                                    <nav className={!isFirstClick ? "active" : "active"}>
                                        {images}
                                        <a href="/restaurant-all"><i></i></a>
                                    </nav>
                                </div>
                            </section>

                            <section id="pMenuCate">
                                <nav>
                                    <a
                                        id="btnCateCoupon"
                                        className={selectedCategory === 'coupon' ? 'active' : ''}
                                        onClick={() => handleCategoryChange('coupon')}
                                    >
                                        {t.selectedCategory.coupon}
                                    </a>
                                    <a
                                        id="btnCatePromotion"
                                        className={selectedCategory === 'promotion' ? 'active' : ''}
                                        onClick={() => handleCategoryChange('promotion')}
                                    >
                                        {t.selectedCategory.promotion}
                                    </a>
                                </nav>
                            </section>
                            
                            {/* <section id="pCoupon" style={{ width: "100%", display: 'flex' }}> */}
                            <section id="pCoupon" style={{ width: "100%", display: selectedCategory === 'coupon' ? 'flex' : 'none'}}>
                                <div className="bRestaurantTitle">
                                    {!isFirstClick ? (
                                        <div className="bTitle">
                                            <div className="bLogo">
                                                <img src={selectedBrand?.logoImg} alt="" />
                                            </div>
                                            <div className="bName">
                                                <h2>{selectedBrand?.name}</h2>
                                                <p className=''> {/* className hide */}
                                                    {selectedBrand?.pointName}
                                                </p>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="bTitle">
                                            <div className="bLogo">
                                                <img src={randomBrands[0]?.logoImg} alt="" />
                                            </div>
                                            <div className="bName">
                                                <h2>{randomBrands[0]?.name}</h2>
                                                <p className=''> {/* className hide */}
                                                    {randomBrands[0]?.pointName}
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                    {/* {hasBranch ?
                                        <div className="bBranch">
                                            <p>{t.coupon.selectBranch}</p>
                                            <div className="control-group">
                                                <div className="select">
                                                    <select value={selectedBranchId} onChange={(e) => setSearchParams({ ...tempParams, branchId: e.target.value })}>
                                                        {branch?.map((branchs, index) => (
                                                            <option key={index} value={branchs.id}>{branchs.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        : ""} */}
                                </div>
                                <div className="bFilter">
                                    <nav>
                                        <a className={selectedCouponTypeId == 0 ? "active" : ""} onClick={() => handleCouponTypeClick(0)}>{t.coupon.all}</a>
                                        <a className={selectedCouponTypeId == 2 ? "active" : ""} onClick={() => handleCouponTypeClick(2)}>{couponType?.filter(item => item.id == 2)[0]?.name}</a>
                                        <a className={selectedCouponTypeId == 1 ? "active" : ""} onClick={() => handleCouponTypeClick(1)}>{couponType?.filter(item => item.id == 1)[0]?.name}</a>
                                        <a className={selectedCouponTypeId == 3 ? "active" : ""} onClick={() => handleCouponTypeClick(3)}>{couponType?.filter(item => item.id == 3)[0]?.name}</a>
                                        {/* {couponType?.map((item, index) => (
                                            <a key={index} className={selectedCouponTypeId === item.id ? "active" : ""} onClick={() => handleCouponTypeClick(item.id)}>{item.name}</a>
                                        ))} */}
                                    </nav>
                                </div>
                                <div className="bCouponMain">
                                    {
                                        rowCount > 0
                                            ? (
                                                <div className="bGroup">
                                                    {coupon?.map((item, index) => (
                                                        <a onClick={() => handleCouponClick(item.couponId, item.restaurantBranchId, item.restaurantId,item)} className={checkLimit(item) ? "bCoupon soldout" : "bCoupon"} key={item.id}>
                                                            <div className="bPic">
                                                                <img src={item.logo} alt="item.name" />
                                                                <div className="bTag"><span>{findCouponTypeName(item.couponType)}</span></div>
                                                                <div className="bSoldout">{t.coupon.soldout}</div>
                                                            </div>
                                                            <div className="bText">
                                                                <div className="bTitle">
                                                                    <h3>{item?.restaurantName}</h3>
                                                                    <p>{item?.name}</p>
                                                                </div>
                                                                <div className="bCondition">
                                                                    {item.usedPoint == 0 ? <div className="tFree"><p>{t.coupon.now}</p></div> : ""}
                                                                    {item.usedPoint == 0 ? "" : <div className="tPoint"><p>{t.coupon.usePoint}<span><i>{item.usedPoint}</i> {t.coupon.points}</span></p></div>}
                                                                </div>
                                                            </div>
                                                        </a>
                                                    ))}
                                                </div>
                                            )
                                            : <EmptyCoupon />
                                    }

                                </div>
                            </section>

                            <section id="pPromotion" style={{ width: "100%", display: selectedCategory === 'promotion' ? 'flex' : 'none'}}>
                                <div className="bPromotionMain">
                                    {
                                        rowCountPromotion > 0
                                            ? (
                                                <div className="bGroup">
                                                    {promotion?.map((item, index) => (
                                                        <a onClick={() => handlePromotionClick(item.promotionId, item.restaurantId,item)} className="bPromotion" key={item.id}>
                                                            <article>
                                                                <div className="bPic">
                                                                    <img src={item.img} alt={`Promotion ${index + 1}`} />
                                                                </div>
                                                            </article>
                                                        </a>
                                                    ))}
                                                </div>
                                            )
                                            : <EmptyPromotion />
                                    }
                                </div>
                            </section>
                            {/* {
                                rowCount > 0
                                    ? (
                                        <Pagination
                                            limit={limit}
                                            offset={offset}
                                            rowCount={rowCount}
                                            onBack={(limit, offset) => {
                                                setSearchParams({ ...tempParams, offset });
                                            }}
                                            onNext={(limit, offset) => {
                                                setSearchParams({ ...tempParams, offset });
                                            }}
                                        />

                                    )
                                    : <></>
                            } */}
                            {
                                selectedCategory === 'coupon' && rowCount > 0 ? (
                                    <Pagination
                                        limit={limit}
                                        offset={offset}
                                        rowCount={rowCount}
                                        onBack={(limit, offset) => {
                                            setSearchParams({ ...tempParams, offset });
                                        }}
                                        onNext={(limit, offset) => {
                                            setSearchParams({ ...tempParams, offset });
                                        }}
                                    />
                                ) : selectedCategory === 'promotion' && rowCountPromotion > 0 ? (
                                    <Pagination
                                        limit={limit}
                                        offset={offset}
                                        rowCount={rowCountPromotion}
                                        onBack={(limit, offset) => {
                                            setSearchParams({ ...tempParams, offset });
                                        }}
                                        onNext={(limit, offset) => {
                                            setSearchParams({ ...tempParams, offset });
                                        }}
                                    />
                                ) : (
                                    <></>
                                )
                            }
                            <BottomCustomer coupon={"active"} />
                        </div>
                    </main>
                </div>
            </PullToRefresh>
        </div>
    )
}

export default CouponAll